import React from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-light-svg-icons/faCheck';
import { TypedMemo } from '../../../../common/types';
import { studioMessages } from '../studioMessages';
import { StudioDetailsProps } from './props';
import { SongWindowPicker } from './SongWindowPicker';
import { DetailField } from './DetailField';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the Studio; each part uses its own slice of it */
import styles from '../Studio.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** The window that step 3 shows: the Canvas is four bars of the song, at most 8 s. */
const CANVAS_WINDOW_SEC = 8;

/**
 * Step 3 for the Canvas loop (design n2, c1 trimmed; asset-redesign s): the part of the song, then
 * the static spec check list. The loop is four bars of the song (owner answer 2026-10-08), so step 3
 * has no length choice. The render output is checked again on the server.
 */
const CanvasDetailsComponent: React.FC<StudioDetailsProps> = ({ details, song, onChange }) => {
  const intl = useIntl();
  const lengthSec = CANVAS_WINDOW_SEC;
  const startSec = details.windowStartSec ?? song.hookStartSec ?? 0;
  const rules = [
    intl.formatMessage(studioMessages.specSize),
    intl.formatMessage(studioMessages.specLoopBars),
    intl.formatMessage(studioMessages.specText),
    intl.formatMessage(studioMessages.specBottom),
  ];

  return (
    <>
      <SongWindowPicker
        durationSec={song.durationSec}
        hookStartSec={song.hookStartSec}
        startSec={startSec}
        lengthSec={lengthSec}
        onStartChange={(windowStartSec) => onChange({ windowStartSec })}
      />
      <DetailField
        title={intl.formatMessage(studioMessages.specTitle)}
        hint={intl.formatMessage(studioMessages.specHint)}
      >
        <ul className={styles.specList}>
          {rules.map((rule) => (
            <li key={rule}>
              <FontAwesomeIcon icon={faCheck} className="me-2" />
              {rule}
            </li>
          ))}
        </ul>
      </DetailField>
    </>
  );
};

export const CanvasDetails = TypedMemo(CanvasDetailsComponent);
